import {Box} from '@mui/material';
import {ApartmentOutlined} from '@mui/icons-material';
import {FC, useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import AMPModal from 'src/components/common/AMPModal';
import {ReOwnersForm} from 'src/components/forms/ReOwnersForm';
import {ReOwnersTable} from 'src/components/common/ReOwner/ReOwnersTable';
import {useCan} from 'src/permissions/hooks';

export const ReOwner: FC = () => {
    const intl = useIntl();



    const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);

    const reOwnerDialogTitle = intl.formatMessage({id: 'createNewReOwner'});
    const canCreate = useCan('realEstates.create');

    useEffect(() => {
    }, []);

    return (
        <Box>
            <ReOwnersTable
                isDialogVisible={isDialogVisible}
                title={intl.formatMessage({id: 'reOwner'})}
                // The permission the create endpoint checks; the button was offered to anyone who
                // could open the page.
                buttonText={canCreate ? 'addReOwner' : undefined}
                onlyTitle={!canCreate}
                onAddClick={() => setIsDialogVisible(true)}
                icon={<ApartmentOutlined/>}
            />
            <AMPModal
                handleClose={() => setIsDialogVisible(false)}
                open={isDialogVisible}
                title={reOwnerDialogTitle}
                type="md"
                fullWidth
                withoutPaddings
            >
                <ReOwnersForm closeDialog={() => setIsDialogVisible(false)}/>
            </AMPModal>
        </Box>
    );
};
